<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px">
            <section class="widget">
                <!-- tabla -->
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <dropdownCustom *ngIf="verlista" [titulo]="'lista de hijos'" [(ngModel)]="alumnoid" [buscar]="false" [opciones]="listaalumno" (ngModelChange)="Filtro($event)" displayValor="alumno" valorName="alumnoid" propiedad="alumnoid"></dropdownCustom>
                    </div>
                </div>
                <div class="base">
                    <!-- datos -->
                    <dx-data-grid
                        (onOptionChanged)="sistemaService.CambiarPaginacionTabla($event)"
                        id="tabla"
                        [columnAutoWidth]="true"
                        [dataSource]="dataTable"
                        [showColumnHeaders]="true"
                        >

                        <dxo-search-panel
                            [visible]="true"
                            [width]="240"
                            placeholder="{{'Buscar' | translate}}">
                        </dxo-search-panel>

                        <dxo-paging [pageSize]="0"></dxo-paging>
                        <!--<dxo-scrolling mode="virtual" [useNative]="false" [showScrollbar]="'always'"></dxo-scrolling>-->

                        <dxo-pager
                            [visible]="false"
                            [allowedPageSizes]="sistemaService.tablaPaginacionPaginaSize"
                            [displayMode]="sistemaService.tablaPaginacionModo"
                            [showPageSizeSelector]="sistemaService.tablaPaginacionSelector"
                            [showInfo]="sistemaService.tablaPaginacionInfo"
                            [showNavigationButtons]="sistemaService.tablaPaginacionNavegacion">
                        </dxo-pager>

                        <dxi-column
                            [allowExporting]="false"
                            caption="Acciones"
                            cellTemplate="cellAcciones"
                            alignment="center">

                        </dxi-column>
                        <dxi-column
                            dataField="periodo"
                            caption="Periodo E360">
                        </dxi-column>
                        <dxi-column
                            dataField="persona"
                            caption="Persona a evaluar">
                        </dxi-column>
                        <dxi-column
                            dataField="materia"
                            caption="Materia Taller">
                        </dxi-column>
                        <dxi-column
                            dataField="estatus"
                            caption="Estatus">
                        </dxi-column>
                        <dxi-column
                            dataField="relacion"
                            caption="Relación">
                        </dxi-column>
                        <dxi-column
                            dataField="departamento"
                            caption="Departamento">
                        </dxi-column>
                        <dxi-column
                            dataField="puesto"
                            caption="Puesto">
                        </dxi-column>
                        <dxi-column
                            [allowExporting]="false"
                            caption="Imagen"
                            dataField="urlfotografia"
                            cellTemplate="cellImagenes"
                            alignment="center"
                            [minWidth]="120">

                        </dxi-column>
                        <!-- Acciones -->
                        <div *dxTemplate="let cell of 'cellAcciones'">
                            <div class="row">
                                <div class="col-lg-12">
                                    <button class="btn botongeneral buttonevaluacion" [disabled]="cell.data.evaluacionpendienteestatusid == 1"
                                    (click)="Formulario(cell.data)">
                                    <span > {{'Evaluar'}}</span>
                                </button>
                                <div class="divisorH16 "></div>
                                <button class="btn botongeneral botonnoloconzco" *ngIf="cell.data.preguntaloconoces" [disabled]="cell.data.evaluacionpendienteestatusid == 1"
                                        (click)="Terminar(cell.data)">
                                    <span > {{'No lo conozco'}}</span>
                                </button>
                                </div>
                            </div>

                        </div>
                        <div *dxTemplate="let cellImagenes of 'cellImagenes'">
                            <div class="imagenPerfilevaluacion popup-button" *ngIf="cellImagenes.value">
                                <div class="marcoevaluacion" >
                                    <div class="imagenPanelevaluacion">
                                        <img [src]="cellImagenes.value  | Imagen | async" id="ImagenPerfil" />
                                    </div>
                                </div>
                                <div class="popup">
                                    <div class="row">
                                        <div class="col-lg-12 contorno">
                                            <div class="imagenPerfil">
                                                <div class="marco">
                                                    <div class="imagenPanel">
                                                        <img [src]="cellImagenes.value  | Imagen | async" id="ImagenPerfilmayor">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </dx-data-grid>
                </div>
            </section>
        </div>
    </div>
</div>
<div #containerEvaluacion></div>